import { Configuration } from './services/ConfigurationService'

const  configuration: Configuration = {

    APIBaseURL: 'https://anujaeetu-api.azurewebsites.net/api/'
}

export default configuration;